import { render } from "./AboutTos.vue?vue&type=template&id=5ca323c1&ts=true"
import script from "./AboutTos.vue?vue&type=script&lang=ts"
export * from "./AboutTos.vue?vue&type=script&lang=ts"

import "./AboutTos.vue?vue&type=style&index=0&id=5ca323c1&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__